import React from 'react';
import { FormattedMessage } from 'react-intl';
import api from '../../../api/EntitiesAudit.api';
import withSelection from './../../../reusable/LightTable/hoc/Selectable';
import LightTable from './../../../reusable/LightTable/VeryLightTable';
import { ENTITIES_PAGE_SIZE, SORT } from '../../../constants';
import { compose } from 'redux';
import withSearch from '../../../reusable/LightTable/hoc/Searchable';
import withInfiniteScroll from '../../../reusable/LightTable/hoc/Scrollable';
import TableCoreComponent from '../../../reusable/LightTable/TableCoreComponent';
import { ActiveLabel, DeletedLabel, BoldedCell, TextCell } from '../../../reusable/LightTable/Components';
import withSort from '../../../reusable/LightTable/hoc/Sortable';
import { sortBy } from 'lodash';

const Table = compose(
    withSelection,
    withSort,
    withSearch,
    withInfiniteScroll
)(LightTable);

export default class EntitiesAuditCategoriesTable extends TableCoreComponent {
    constructor(props) {
        super(props);

        const defaultLoadParams = {
            filters:    {query: "", categoryIdFilter: "defaultAllCategories", active: "all"},
            sorting:    {sortBy: "active", direction: SORT.DESC},
            pagination: {pageNumber: 0, pageSize: ENTITIES_PAGE_SIZE},
            reset:      false
        };

        this.defaultLoadParams = this.loadParams = defaultLoadParams;
        this.api = api;
    }

    componentDidMount() {
        super.componentDidMount();
    }

    formatItem = (item, searchTerm = "") => {
        return {
            key: item.id,
            companyTitle: <BoldedCell value={item.companyTitle} searchTerm={searchTerm} />,
            dunsNumber: <BoldedCell value={item.dunsNumber} searchTerm={searchTerm} />,
            active: <TextCell>{item.deleted ? <DeletedLabel /> : <ActiveLabel isActive={item.active}/>}</TextCell>,
            object: item
        }
    };

    formatSelectedItem = (item) => <span>{item.companyTitle}</span>;

    headerItems = [
        {
            key: "companyTitle",
            label: <FormattedMessage id='Entities_Edit_UIText_thirdPartyListing.titleColumnHeading'/>
        },
        {
            key: "dunsNumber",
            label: <FormattedMessage id={"Entities_Review_Error_errorCompanies.CompanyDuns"}/>
        },
        {
            key: "active",
            label: <FormattedMessage id={"Entities_Edit_UIText_thirdPartyListing.statusColumnHeading"}/>,
            sortable: true
        }
    ];

    handleSelectionChange(selectedItems) {
        this.setState({ selectedItems });
        this.props.onUpdateSelection(selectedItems.map(item => item.object.id));
    };

    selectAllToggle() {
        if (this.state.selectedItems.length === this.state.totalCount) {
            this.setState({ selectedItems: [] });
            this.props.onUpdateSelection([]);
        } else {
            this.api.get(this.defaultLoadParams.filters, this.defaultLoadParams.sorting, { pageNumber: -1, pageSize: -1 }).then(items => {
                let itemsForSelection = items.body.map(item => this.formatItem(item));
                this.setState({ selectedItems: itemsForSelection});
                this.props.onUpdateSelection(itemsForSelection.map(item => item.object.id));
            })
        }
    }



    render = () =>
        <div className="selectable-table empty-category-table">
            <Table {...this.getTableProps()}
                   selectedItems={sortBy(this.state.selectedItems, item => item.companyTitle.props.value.toLowerCase())}/>
        </div>
}


// WEBPACK FOOTER //
// ./src/scripts/pages/AccountUsage/Components/EntitiesAuditEntitiesTable.jsx